var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex"}},[_c('div',{staticStyle:{"flex-shrink":"0"}},[_c('h1',{style:(_vm.textStyle)},[_vm._v(" "+_vm._s(_vm.formattedText)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }